import {Component } from '@angular/core';
import { PublicTimelineItem, PublicEventInfo, PublicEventData } from 'globals/store/public.model';
import { ActivatedRoute } from '@angular/router';
import { environment } from './../../../../src/environments/environment'
import { HttpClient } from "@angular/common/http";
import { take } from 'rxjs/operators';
import { getDefaultProgramTabNames } from 'globals/store/share.data';
import { updateOldPublishedEventInPlace } from '../../helpers/helpers';
import { Venue } from 'globals/store/events.data';
import { DomSanitizer } from '@angular/platform-browser';
import { BrandingData, HomePageData } from 'globals/store/publish.data';
import { PublishTimelineComponent } from 'src/app/components/publish-timeline/publish-timeline';

@Component({
    selector: 'share-page',
    template: `
<publish-timeline 
  [joiEvent]="eventInfo"
  [brandingData]="brandingData"
  [homePageData]="homePageData"
  [fromShare]="true" 
  [madeWithJoi]="madeWithJoi" 
  [version]="version"
  [data]="timeline" 
  [venue]="venue"
  [tabNames]="tabNames"
  [CTALinks]="CTALinks"
  [loading]="loading"
  [excludedFieldIds]="excludedFieldIds || []"
  [title]="(excludedFieldIds || []).includes('publishedName') ? '' : eventInfo?.title || ''"
></publish-timeline>
    `,
    styleUrls: ['./share.page.scss'],
    standalone: true,
    imports: [PublishTimelineComponent]
})
export class SharePageComponent {

    readonly api = `${environment.functionsURL}api/v1`; // NOTE this is pointing to api/v1 not api/app
    publishCode:string;
    timeline:PublicTimelineItem[][] = [];
    eventInfo:PublicEventInfo = null;
    excludedFieldIds: string[]
    tabNames:{ [tId: string]: string } = getDefaultProgramTabNames() // defaults
    loading = true;
    madeWithJoi = true
    venue: Venue
    version: number
    CTALinks
    brandingData: BrandingData
    homePageData: HomePageData

    constructor( private route:ActivatedRoute, private http:HttpClient, public sanitizer: DomSanitizer ) {
      this.route.params.subscribe(params=>{
        console.log({ params })
        if(!params || !params.hasOwnProperty('publishCode')) {
          this.loading = false;
          document.title = "Timeline unavailable";
        } else {
          this.publishCode = params.publishCode;
          this.sharedDownloadPublishedEvent(this.publishCode)
        }
        document.title = "loading";
      })
    }

    sharedDownloadPublishedEvent(publishCode){
      const url = `${this.api}/load-published-data`
      console.log({ url, publishCode })
      this.http.post(url, { publishCode }).pipe(take(1)).subscribe((data: PublicEventData) => {
        console.log({ data })
        if(data.customPublishCSSUrl) {
          const cssId = 'myCss';  // you could encode the css path itself to generate id..
          if (!document.getElementById(cssId)){
            const head  = document.getElementsByTagName('head')[0];
            const link  = document.createElement('link');
              link.id   = cssId;
              link.rel  = 'stylesheet';
              link.type = 'text/css';
              link.href = data.customPublishCSSUrl;
              link.media = 'all';
              head.appendChild(link);
          }

        }
        this.loadData(data);
        this.loading = false;
      }, (response) => {
        console.error('Error loading published event data', response)
        this.loading = false;
        document.title = "Timeline unavailable";
      });
    }

    loadData(data: PublicEventData){
      // starLog("LOADING DATA")
      // console.log(data)
      if(data && !data.error){
        
        this.eventInfo = data.eventInfo || null
        if (this.eventInfo) updateOldPublishedEventInPlace(data)
        this.timeline = data.timeline || []
        this.venue = data.venue || null
        this.CTALinks = data.CTALinks || null;
        this.version = data.internalVersion || 0
        // THESE THREE LINES EXTRACT OLD VENUES INTO NEW ONES

        if (data.tabNames) this.tabNames = data.tabNames
        document.title = this.eventInfo.event_title || this.eventInfo.title || this.eventInfo.description || 'Untitled Event from Joi'
        this.madeWithJoi = !data.hideMadeWithJoi
        if(!this.eventInfo.exhibitorIds){
          delete this.tabNames.exhibitorsTab
        }
        this.excludedFieldIds = data.excludedFieldIds
        this.brandingData = data.brandingData
        this.homePageData = data.homePageData
      }else{
        document.title = "Timeline unavailable";
      }
    }
}

